/* ARKS theme behaviour.
 *
 * Plain JavaScript, no framework and no build step. The concept build used
 * React for five pieces of state; all five are reproduced here so the theme
 * has no runtime dependency beyond itself.
 *
 * Everything re-initialises on shopify:section:load so the theme editor
 * behaves when a merchant edits a section.
 */
(function () {
  "use strict";

  var reduced = window.matchMedia("(prefers-reduced-motion: reduce)").matches;

  /* ---------- hero carousel ---------------------------------------- */
  function hero(root) {
    var frames = root.querySelector("[data-arks-carousel]");
    var dotWrap = root.querySelector("[data-arks-dots]");
    if (!frames) return;
    var imgs = Array.prototype.slice.call(frames.querySelectorAll(".hero-img"));
    var dots = dotWrap ? Array.prototype.slice.call(dotWrap.querySelectorAll(".hero-dot")) : [];
    if (imgs.length < 2) return;

    var i = 0, paused = false, timer = null;

    function show(n) {
      i = n;
      imgs.forEach(function (im, k) {
        im.classList.toggle("is-on", k === n);
        if (k === n) im.removeAttribute("aria-hidden");
        else im.setAttribute("aria-hidden", "true");
      });
      dots.forEach(function (d, k) {
        d.classList.toggle("is-on", k === n);
        if (k === n) d.setAttribute("aria-current", "true");
        else d.removeAttribute("aria-current");
      });
    }

    function start() {
      if (reduced || timer) return;
      timer = window.setInterval(function () {
        if (paused) return;
        // a random frame, never the one already showing
        var n = Math.floor(Math.random() * imgs.length);
        if (n === i) n = (i + 1) % imgs.length;
        show(n);
      }, 5200);
    }

    dots.forEach(function (d, k) {
      d.addEventListener("click", function () { show(k); });
    });
    if (dotWrap) {
      dotWrap.addEventListener("mouseenter", function () { paused = true; });
      dotWrap.addEventListener("mouseleave", function () { paused = false; });
    }
    show(0);
    start();
  }

  /* ---------- ways to wear tabs ------------------------------------ */
  function wear(root) {
    var tabs = Array.prototype.slice.call(root.querySelectorAll("[data-arks-weartab]"));
    var panels = Array.prototype.slice.call(root.querySelectorAll("[data-arks-wearpanel]"));
    if (!tabs.length) return;
    tabs.forEach(function (t, k) {
      t.addEventListener("click", function () {
        tabs.forEach(function (x, n) { x.setAttribute("aria-selected", n === k ? "true" : "false"); });
        panels.forEach(function (p, n) {
          if (n === k) p.removeAttribute("hidden");
          else p.setAttribute("hidden", "");
        });
      });
    });
  }

  /* ---------- length helper in the shop section -------------------- */
  function sizing(root) {
    var btns = Array.prototype.slice.call(root.querySelectorAll("[data-arks-sizelen]"));
    var note = root.querySelector("[data-arks-sizenote]");
    if (!btns.length) return;
    function pick(k) {
      btns.forEach(function (b, n) { b.setAttribute("aria-pressed", n === k ? "true" : "false"); });
      if (note) note.textContent = btns[k].getAttribute("data-for") || "";
    }
    btns.forEach(function (b, k) { b.addEventListener("click", function () { pick(k); }); });
    var initial = btns.findIndex ? btns.findIndex(function (b) { return b.getAttribute("aria-pressed") === "true"; }) : -1;
    pick(initial > -1 ? initial : 0);
  }

  /* ---------- configurator ----------------------------------------- */
  function configurator(root) {
    var fins = Array.prototype.slice.call(root.querySelectorAll("[data-arks-finish]"));
    var lens = Array.prototype.slice.call(root.querySelectorAll("[data-arks-length]"));
    var plugs = Array.prototype.slice.call(root.querySelectorAll("[data-arks-plug]"));
    if (!fins.length) return;

    var stage = root.querySelector("[data-arks-stage]");
    var finName = root.querySelector("[data-arks-finish-name]");
    var finBlurb = root.querySelector("[data-arks-finish-blurb]");
    var finSpec = root.querySelector("[data-arks-finish-spec]");
    var lenName = root.querySelector("[data-arks-length-name]");
    var lenFor = root.querySelector("[data-arks-length-for]");
    var plugName = root.querySelector("[data-arks-plug-name]");
    var plugNote = root.querySelector("[data-arks-plug-note]");
    var summary = root.querySelector("[data-arks-summary]");
    var priceEl = root.querySelector("[data-arks-price]");
    var input = root.querySelector("[data-arks-variant-input]");
    var submit = root.querySelector("[data-arks-submit]");
    var json = root.querySelector("[data-arks-variants]");
    var buyLink = root.querySelector("[data-arks-buylink]");

    // Fulfilment line shown beside the configured set. Standard shipping is
    // 3 to 5 business days everywhere. If that changes, change it here and in
    // the FAQ block in templates/index.json, which is the other place it
    // appears.
    var SHIP_NOTE = "In stock, ships in 3 to 5 business days";

    var variants = [];
    if (json) { try { variants = JSON.parse(json.textContent); } catch (e) { variants = []; } }
    // Fall back to the map shipped with the theme. A cross-origin fetch to the
    // live shop is blocked when this theme is previewed on a different store,
    // so the map is what keeps ?variant= correct in that case.
    if (!variants.length) {
      var mapEl = root.querySelector("[data-arks-variant-map]");
      if (mapEl) { try { variants = JSON.parse(mapEl.textContent); } catch (e) {} }
    }

    var fi = Math.max(0, fins.findIndex(function (b) { return b.getAttribute("aria-pressed") === "true"; }));
    var li = Math.max(0, lens.findIndex(function (b) { return b.getAttribute("aria-pressed") === "true"; }));
    var pi = Math.max(0, plugs.findIndex(function (b) { return b.getAttribute("aria-pressed") === "true"; }));

    function money(cents) {
      if (window.Shopify && window.Shopify.formatMoney) return window.Shopify.formatMoney(cents);
      return "$" + (cents / 100).toFixed(2);
    }

    // Append the resolved variant id as a ?variant= param so the shopper
    // lands on the exact configuration they built, not Shopify's default.
    function withVariant(base, variantId) {
      if (!base || !variantId) return base;
      var clean = base.replace(/([?&])variant=\d+&?/, "$1").replace(/[?&]$/, "");
      var sep = clean.indexOf("?") > -1 ? "&" : "?";
      return clean + sep + "variant=" + variantId;
    }

    // Work out WHICH option position each selector controls, then match on
    // position. Matching a value anywhere in the options array is unsafe here:
    // this product uses "Gold" for both a chain finish and an earplug colour,
    // so a loose match sends a Gold-chain shopper a Silver chain with gold
    // plugs. A selector owns the position where ALL of its values appear.
    var pos = { fin: -1, len: -1, plug: -1 };
    var positionsComputed = false;
    function valuesOf(btns, attr) {
      return btns.map(function (b) { return (b.getAttribute(attr) || "").trim(); }).filter(Boolean);
    }
    function positionFor(values) {
      if (!values.length) return -1;
      for (var i = 0; i < 3; i++) {
        var all = values.every(function (val) {
          return variants.some(function (v) { return String((v.options || [])[i] || "").trim() === val; });
        });
        if (all) return i;
      }
      return -1;
    }
    function computePositions() {
      pos.fin = positionFor(valuesOf(fins, "data-option"));
      pos.len = positionFor(valuesOf(lens, "data-option"));
      pos.plug = positionFor(valuesOf(plugs, "data-option"));
      positionsComputed = true;
      // Loud in the console, silent for the shopper. A selector that cannot be
      // placed is a theme configuration error: one of its buttons carries an
      // option value the product no longer has. See the refusal in
      // findVariant below.
      if (pos.fin === -1 || (lens.length && pos.len === -1) || (plugs.length && pos.plug === -1)) {
        if (window.console && console.warn) {
          console.warn("[ARKS] configurator: an option selector could not be matched to this product.", pos);
        }
      }
    }
    function findVariant(fopt, lopt, popt) {
      if (!positionsComputed) computePositions();

      // A selector whose option position could not be resolved must NEVER be
      // quietly skipped. Skipping it was the old behaviour and it silently
      // resolved to the first variant that happened to match the remaining
      // selectors, meaning a shopper could choose one thing and be sent to
      // buy another. Refusing to resolve is the only safe answer.
      if (pos.fin === -1) return null;
      if (lens.length && pos.len === -1) return null;
      if (plugs.length && pos.plug === -1) return null;

      for (var v = 0; v < variants.length; v++) {
        var o = (variants[v].options || []).map(function (x) { return String(x || "").trim(); });
        if (o[pos.fin] !== fopt) continue;
        if (lopt && o[pos.len] !== lopt) continue;
        if (popt && o[pos.plug] !== popt) continue;
        return variants[v];
      }
      return null;
    }

    function render() {
      var f = fins[fi], l = lens[li], pg = plugs.length ? plugs[pi] : null;
      fins.forEach(function (b, n) { b.setAttribute("aria-pressed", n === fi ? "true" : "false"); });
      lens.forEach(function (b, n) { b.setAttribute("aria-pressed", n === li ? "true" : "false"); });
      plugs.forEach(function (b, n) { b.setAttribute("aria-pressed", n === pi ? "true" : "false"); });

      var fname = f.getAttribute("data-name") || "";
      var fopt = f.getAttribute("data-option") || fname;
      var lopt = l ? (l.getAttribute("data-option") || "") : "";
      var popt = pg ? (pg.getAttribute("data-option") || "") : "";

      if (finName) finName.textContent = fname;
      if (finBlurb) finBlurb.textContent = f.getAttribute("data-blurb") || "";
      if (finSpec) finSpec.textContent = f.getAttribute("data-spec") || "";
      if (lenName) lenName.textContent = lopt;
      if (lenFor && l) lenFor.textContent = l.getAttribute("data-for") || "";
      if (plugName) plugName.textContent = popt;

      if (stage) stage.dispatchEvent(new CustomEvent("arks:finish", { detail: f.getAttribute("data-key") }));

      var variant = variants.length ? findVariant(fopt, lopt, popt) : null;
      var note = SHIP_NOTE;
      var sellable = true;

      if (variants.length) {
        if (!variant) { sellable = false; note = "That combination is not offered"; }
        else if (!variant.available) { sellable = false; note = "Out of stock"; }
      }

      if (plugNote) {
        plugNote.textContent = sellable ? "" : note;
      }

      // Every other buy button on the page follows this choice too. Without
      // this a shopper picks a finish here, presses "Buy the set" further
      // down and lands on whatever variant Shopify defaults to.
      if (variant) {
        var others = document.querySelectorAll("[data-arks-follows]");
        for (var q = 0; q < others.length; q++) {
          var el = others[q];
          var b = el.getAttribute("data-base") || el.getAttribute("href") || "";
          if (b) el.setAttribute("href", withVariant(b, variant.id));
        }
      }

      // hand the exact variant to Shopify
      if (buyLink) {
        var base = buyLink.getAttribute("data-base") || buyLink.getAttribute("href") || "";
        buyLink.setAttribute("href", variant ? withVariant(base, variant.id) : base);
        buyLink.setAttribute("aria-disabled", sellable ? "false" : "true");
      }
      if (variant && input) input.value = variant.id;
      if (variant && priceEl && typeof variant.price === "number") priceEl.textContent = money(variant.price);
      if (submit) {
        submit.disabled = !sellable;
        submit.textContent = sellable ? (submit.getAttribute("data-label") || "Add to cart") : note;
      }
      if (summary) summary.textContent = fname + " · " + lopt + (popt ? " · " + popt + " earplugs" : "") + " · " + note;
    }

    // If no product was connected in the theme editor, read the live product
    // straight from Shopify so the variant map is never stale or invented.
    var wrap = root.closest ? root.closest("[data-product-path]") : null;
    var path = root.getAttribute("data-product-path") || (wrap && wrap.getAttribute("data-product-path"));
    var sameOrigin = !path || path.indexOf("http") !== 0 || path.indexOf(window.location.origin) === 0;
    if (path && sameOrigin) {
      fetch(path.split("?")[0] + ".js", { headers: { Accept: "application/json" } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (d) { if (d && d.variants) { variants = d.variants; computePositions(); render(); } })
        .catch(function () {});
    }

    fins.forEach(function (b, k) { b.addEventListener("click", function () { fi = k; render(); }); });
    lens.forEach(function (b, k) { b.addEventListener("click", function () { li = k; render(); }); });
    plugs.forEach(function (b, k) { b.addEventListener("click", function () { pi = k; render(); }); });
    if (submit && !submit.getAttribute("data-label")) submit.setAttribute("data-label", submit.textContent.trim());
    render();
  }

  /* ---------- sticky buy bar --------------------------------------- */
  function buybar() {
    var bar = document.querySelector("[data-arks-buybar]");
    if (!bar) return;
    function onScroll() {
      bar.classList.toggle("buybar-on", window.scrollY > window.innerHeight * 0.9);
    }
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  function init(scope) {
    var root = scope || document;
    root.querySelectorAll(".hero").forEach ? root.querySelectorAll(".hero").forEach(hero) : null;
    Array.prototype.slice.call(root.querySelectorAll("[data-arks-wear]")).forEach(wear);
    Array.prototype.slice.call(root.querySelectorAll("[data-arks-sizing]")).forEach(sizing);
    Array.prototype.slice.call(root.querySelectorAll("[data-arks-cfg]")).forEach(configurator);
    buybar();
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener("shopify:section:load", function (e) { init(e.target); });
})();